const IconChecked = () => (
  <svg
    width='21'
    height='23'
    viewBox='0 0 21 23'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16.8 0.65625H4.2C1.8804 0.65625 0 2.53665 0 4.85625V17.4563C0 19.7758 1.8804 21.6562 4.2 21.6562H16.8C19.1196 21.6562 21 19.7758 21 17.4563V4.85625C21 2.53665 19.1196 0.65625 16.8 0.65625Z'
      fill='#1C6EC9'
    />
    <path
      d='M6.30103 11.1564L9.5318 14.3064L14.7011 8.00638'
      stroke='white'
      strokeWidth='1.6'
    />
  </svg>
);

export default IconChecked;
